import {TradingAccountDetailedReportModel} from '@spa/api';

import {SelectControl} from '../../../app/shared/classes/controls';
import {ComponentTypesEnum} from '../../../app/shared/enums/common';
import {
    DialogButtonTypesEnum,
    DialogConfigInterface,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from '../../../app/shared/components';

export const EditAccountAddUserSelector = 'addUser';

export const PanelAccountEditDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingAccountDetailedReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: TradingAccountDetailedReportModel.getAvailableCashSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingAccountDetailedReportModel.getCurrencyCodeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: TradingAccountDetailedReportModel.getLastTradeDateSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const AddRouteSetAssociationDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const AddRBrokerAssociationDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const PanelAccountEditDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account Number',
                selector: TradingAccountDetailedReportModel.getAccountReferenceIdSelector()
            }),
            new ReportTableColumn({
                label: 'Balance',
                selector: TradingAccountDetailedReportModel.getAvailableCashSelector()
            }),
            new ReportTableColumn({
                label: 'Currency',
                selector: TradingAccountDetailedReportModel.getCurrencyCodeSelector()
            }),
            new ReportTableColumn({
                label: 'Last Trade Date',
                selector: TradingAccountDetailedReportModel.getLastTradeDateSelector()
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export const EditAccountAddUserControl = (): SelectControl => {
    return new SelectControl({
        name: EditAccountAddUserSelector,
        value: null,
        placeholder: 'User',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    });
};
